const now = new Date()
export const defaultConfigState = {
  /**
   * Cờ đang xử lý
   */
  Loading: false,
  /**
   * Token đăng nhập
   */
  Token: null,
  /**
   * Thời điểm  token hết hạn
   */
  TokenExpired: null,
  /*
   * Trạng thái Collapse của left menu
   */
  LeftMenuCollapse: false,
  /**
   * Thông tin phân quyền
   * Key là subsystemCode, value sẽ là mảng string danh sách perrmission
   */
  Permission: {},
  /**
   * Thông tin thuê bao
   */
  License: {},
  /**
   * Thông tin tài khoản
   */
  User: {
    UserID: null,
    Email: null,
    FullName: null,
    Mobile: null,
    UserName: null,
  },
  /**
   * Thông tin config
   */
  ConfigInfo: {
    CurrentDate: new Date(now.getFullYear(), now.getMonth(), now.getDay()),
    CurrentDateText: '',
  },
  /**
   * Định dạng số
   */
  NumberFormat: {
    GeneralDecimalSeparator: ',',
    GeneralGroupSeparator: '.',
    QuantityDecimalDigits: 1,
    AmountDecimalDigits: 0,
    UnitPriceDecimalDigits: 1,
    ExchangRateDecimalDigits: 2,
    CoefficientDecimalDigits: 2,
  },
  OptionsData: {},
  /**
   * Ngôn ngữ hiện tại
   */
  Culture: 'vi',
  /**
   * Một số thông tin liên quan đến phiên làm việc hiện tại
   * Chỉ có 1 số thông tin ở đây, 1 số thông tin khi submit lên server sẽ lấy từ token: userid, tenantid...
   */
  Context: {},
}

export default {
  ...defaultConfigState,
}
